import { api } from "@/api";
import { LeagueWithTranslations } from "@/types/ApiResponses/League";

export const getLeagueWithTranslations = async (
  id: number
): Promise<LeagueWithTranslations> => {
  const res = await api.client.get(`/leagues-new/with-translations/${id}`);
  return res.data;
};
